module.exports = __webpack_public_path__ + "static/media/1POLICY4.5c8fad47.jpg";